import Formulario from 'components/Formulario/Formulario';

const DadosUsuario = ({inputs, initialValues, onValuesChange, onSubmitableChange, formRef, portalOnInputSufixosValueChange}) =>{
    return(
        <div>
            <Formulario
                formReference={formRef}
                inputsData={inputs}
                initialValues={initialValues}    
                onValuesChange={onValuesChange}              
                submitButtonMessage="Salvar Alterações"
                hideSubmitButton={true}
                onSubmitableChange={onSubmitableChange}
                portalOnInputSufixosValueChange={portalOnInputSufixosValueChange}
            />
        </div>
    )
}

export default DadosUsuario
